/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { makeAPI } from "@/frameworks/core/API";
import GroupService from "./api";

export default function withGroup(events: API.Events) {
	return {
		delete: makeAPI<WebServices.Group.Delete.Response>(GroupService.group.deleteGroup("delete", events)),
		inquiry: {
			...makeAPI<WebServices.Group.Inquiry.Response>(GroupService.group.inquiry("inquiry", events)),
			inquiryWOAuth: makeAPI<WebServices.Group.Inquiry.InquiryWOAuth.Response>(
				GroupService.group.inquiryWOAuth("inquiry:withoutAuth", events)
			)
		},
		spaceList: makeAPI<WebServices.Group.SpaceList.Response>(
			GroupService.group.spaceList("group:spaceList", events)
		),
		create: makeAPI<WebServices.Group.Create.Response>(GroupService.group.create("group:create", events)),
		update: makeAPI<WebServices.Group.Update.Response>(GroupService.group.update("update", events)),
		authorities: makeAPI<WebServices.Group.Authorities.Response>(
			GroupService.group.authorities("authorities", events)
		),
		authoritieList: makeAPI<WebServices.Group.AuthoritieList.Response>(
			GroupService.group.authoritieList("authoritielist", events)
		),
		search: {
			...makeAPI<WebServices.Group.Search.Response>(GroupService.group.search("search", events)),
			allowTypes: makeAPI<WebServices.Group.Search.AllowTypes.Response>(
				GroupService.group.searchAllowTypes("search:allowTypes", events)
			)
		},
		join: {
			list: makeAPI<WebServices.Group.Join.List.Response>(GroupService.group.join.list("join:list", events)),
			request: makeAPI<WebServices.Group.Join.Request.Response>(
				GroupService.group.join.request("join:request", events)
			),
			process: makeAPI<WebServices.Group.Join.Process.Response>(
				GroupService.group.join.process("join:process", events)
			),
			status: makeAPI<WebServices.Group.Join.Status.Response>(
				GroupService.group.join.status("join:status", events)
			),
			cancel: makeAPI<WebServices.Group.Join.Cancel.Response>(
				GroupService.group.join.cancel("join:cancel", events)
			)
		},
		domain: {
			status: makeAPI<WebServices.Group.Domain.Status.Response>(
				GroupService.group.domain.status("domain:status", events)
			)
		},
		roles: makeAPI<WebServices.Group.Role.Response>(GroupService.group.role("roles", events)),
		joined: {
			users: makeAPI<WebServices.Group.Joined.Users.Response>(
				GroupService.group.joined.users("joined:users", events)
			),
			groups: makeAPI<WebServices.Group.Joined.Groups.Response>(
				GroupService.group.joined.groups("joined:groups", events)
			)
		}
	};
}
